import { Editor } from "@tiptap/react";
import { toast } from "sonner";
import $api from "@/zapi-frontend/shared/api/axios";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";

export const uploadImageFile = async (file: File, projectId: string, fileName?: string) => {
  const newFileName = `${fileName?.split(".")[0]}-${projectId}-${Date.now()}.png`;
  const renamedFile = new File([file], newFileName, { type: file.type });

  const response = await $api.post(
    `/projects/${projectId}/public-assets`,
    { file: renamedFile },
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );

  return response.data?.data?.url;
};

const addNewCroppedImage = async (id: number, imageUrl: string) => {
  const currentChapter = useChapterStore.getState().activeChapter;
  if (currentChapter?.id) {
    try {
      await useChapterStore.getState().updateChapterCroppedMemoImage(
        currentChapter.id.toString(),
        {
          id,
          imageUrl,
          tlCoordinateX: 0,
          tlCoordinateY: 0,
          brCoordinateX: 0,
          brCoordinateY: 0
        }
      );
    } catch (error) {
      console.error("Failed to update cropped memo image:", error);
    }
  }
};

export const insertImageIntoEditor = (editor: Editor, imageUrl: string, id: number) => {
  const createdNodeImage = editor.schema.nodes.image.create({ src: imageUrl, imageId: id });
  if (createdNodeImage) {
    const transaction = editor.view.state.tr.replaceSelectionWith(createdNodeImage);
    editor.view.dispatch(transaction);
    return true;
  }
  return false;
};

export const handleImageFileUpload = async (
  file: File,
  editor: Editor,
  projectId: string,
  fileName?: string
) => {
  try {
    const url = await uploadImageFile(file, projectId, fileName);
    if (!url) {
      toast.error("Failed to upload image");
      return false;
    }

    const mockId = Date.now();
    await addNewCroppedImage(mockId, url);
    return insertImageIntoEditor(editor, url, mockId);
  } catch (error) {
    toast.error("Failed to upload image");
    return false;
  }
};

export const handleImageUrlPaste = async (imageUrl: string, editor: Editor) => {
  try {
    const mockId = Date.now();

    await addNewCroppedImage(mockId, imageUrl);
    return insertImageIntoEditor(editor, imageUrl, mockId);
  } catch (error) {
    console.error("Failed to handle image URL paste:", error);
    return false;
  }
};
